export interface Announcement {
  id: number;
  title: string;
  titleKey?: string;
  content: string;
  contentKey?: string;
  type: AnnouncementType;
  createdDate: Date;
  updatedDate: Date;
  author: string;
  authorKey?: string;
  priority: AnnouncementPriority;
  isActive: boolean;
  tags?: string[];
}

export enum AnnouncementType {
  GENERAL = 'general',
  MAINTENANCE = 'maintenance',
  EMERGENCY = 'emergency',
  EVENT = 'event',
}

export enum AnnouncementPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  CRITICAL = 'critical',
}
